// Simple wishlist using localStorage only - no AJAX, no server calls
// Works with native Shopify functionality

(function() {
  'use strict';
  
  var WISHLIST_KEY = 'shopify_wishlist';
  var wishlist = getWishlist();
  
  // Get wishlist from localStorage
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  
  // Save wishlist to localStorage
  function saveWishlist() {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    } catch (e) {
      console.warn('Could not save wishlist');
    }
  }
  
  // Check if product is in wishlist
  function isInWishlist(productId) {
    return wishlist.indexOf(productId) > -1;
  }
  
  // Add product to wishlist
  function addToWishlist(productId) {
    if (!isInWishlist(productId)) {
      wishlist.push(productId);
      saveWishlist();
      updateWishlistButtons();
      updateWishlistCount();
    }
  }
  
  // Remove product from wishlist
  function removeFromWishlist(productId) {
    var index = wishlist.indexOf(productId);
    if (index > -1) {
      wishlist.splice(index, 1);
      saveWishlist();
      updateWishlistButtons();
      updateWishlistCount();
    }
  }
  
  // Update all wishlist buttons on page
  function updateWishlistButtons() {
    // Handle multiple button types: data-wishlist-add, data-product-id, and engoj_add_to_wishlist class
    var buttons = document.querySelectorAll('[data-wishlist-add], [data-product-id], .wishlist-add-btn, .engoj_add_to_wishlist');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var productId = button.getAttribute('data-wishlist-add') || 
                     button.getAttribute('data-product-id');
      
      // For form-based buttons, get product ID from hidden input
      if (!productId && button.closest('form')) {
        var tagInput = button.closest('form').querySelector('input[name="contact[tags]"]');
        if (tagInput) {
          productId = tagInput.value.replace('x', ''); // Remove 'x' prefix if present
        }
      }
      
      if (productId && isInWishlist(productId)) {
        button.classList.add('in-wishlist');
        button.classList.add('added');
        
        // Update icon to filled heart
        var icon = button.querySelector('i');
        if (icon) {
          icon.className = icon.className.replace(/fa-heart-o/g, 'fa-heart');
          icon.style.color = '#e74c3c';
        }
        
        // Update text
        var textEl = button.querySelector('.wishlist-text') || button.querySelector('span');
        if (textEl) {
          textEl.textContent = 'In Wishlist';
        }
      } else if (productId) {
        button.classList.remove('in-wishlist');
        button.classList.remove('added');
        
        // Update icon to outline heart
        var icon = button.querySelector('i');
        if (icon) {
          icon.className = icon.className.replace(/fa-heart/g, 'fa-heart-o');
          icon.style.color = '';
        }
        
        // Update text
        var textEl = button.querySelector('.wishlist-text') || button.querySelector('span');
        if (textEl) {
          textEl.textContent = 'Add to Wishlist';
        }
      }
    }
  }
  
  // Update wishlist counter
  function updateWishlistCount() {
    var counters = document.querySelectorAll('.wishlist-count');
    for (var i = 0; i < counters.length; i++) {
      counters[i].textContent = wishlist.length;
      if (wishlist.length > 0) {
        counters[i].style.display = 'inline-block';
      } else {
        counters[i].style.display = 'none';
      }
    }
  }
  
  // Handle wishlist button clicks
  function handleWishlistClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    var button = e.target.closest('[data-wishlist-add], [data-product-id], .wishlist-add-btn, .engoj_add_to_wishlist');
    if (!button) return;
    
    var productId = button.getAttribute('data-wishlist-add') || 
                   button.getAttribute('data-product-id');
    
    // For form-based buttons, get product ID from hidden input
    if (!productId && button.closest('form')) {
      var tagInput = button.closest('form').querySelector('input[name="contact[tags]"]');
      if (tagInput) {
        productId = tagInput.value.replace('x', ''); // Remove 'x' prefix if present
      }
    }
    
    if (productId) {
      // Add visual feedback
      button.style.opacity = '0.5';
      button.disabled = true;
      
      if (isInWishlist(productId)) {
        removeFromWishlist(productId);
        // Show feedback
        showNotification('Product removed from wishlist', 'info');
      } else {
        addToWishlist(productId);
        // Show feedback
        showNotification('Product added to wishlist!', 'success');
      }
      
      // Re-enable button
      setTimeout(function() {
        button.style.opacity = '1';
        button.disabled = false;
      }, 300);
    } else {
      console.error('No product ID found on wishlist button');
    }
  }
  
  // Show notification
  function showNotification(message, type) {
    var notification = document.createElement('div');
    notification.className = 'wishlist-notification wishlist-' + type;
    notification.textContent = message;
    notification.style.cssText = 'position: fixed; top: 20px; right: 20px; padding: 12px 20px; border-radius: 4px; color: white; font-weight: 500; z-index: 10000; animation: slideIn 0.3s ease;';
    
    if (type === 'success') {
      notification.style.backgroundColor = '#28a745';
    } else if (type === 'info') {
      notification.style.backgroundColor = '#17a2b8';
    } else {
      notification.style.backgroundColor = '#dc3545';
    }
    
    document.body.appendChild(notification);
    
    setTimeout(function() {
      notification.style.opacity = '0';
      notification.style.transform = 'translateX(100%)';
      setTimeout(function() {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  }
  
  // Initialize wishlist
  function init() {
    // Use event delegation to handle all wishlist button types
    document.addEventListener('click', function(e) {
      var button = e.target.closest('[data-wishlist-add], [data-product-id], .wishlist-add-btn, .engoj_add_to_wishlist');
      if (button) {
        handleWishlistClick(e);
      }
    });
    
    // Update initial state
    updateWishlistButtons();
    updateWishlistCount();
    
    // Re-update buttons periodically for dynamic content
    setInterval(function() {
      updateWishlistButtons();
    }, 1000);
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Make functions globally available for templates
  window.shopifyWishlist = {
    add: addToWishlist,
    remove: removeFromWishlist,
    isInWishlist: isInWishlist,
    getAll: function() { return wishlist.slice(); },
    count: function() { return wishlist.length; },
    clear: function() { 
      wishlist = []; 
      saveWishlist(); 
      updateWishlistButtons(); 
      updateWishlistCount(); 
    }
  };
  
  // Add CSS for notifications
  var style = document.createElement('style');
  style.textContent = '@keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }';
  document.head.appendChild(style);
  
})();